import React from "react";
import { Input } from "../../components/Controls/input.jsx";
import { Card, CardContent } from "../../components/Users/card";
import { Select } from "../Controls/Select.js";

export default function DashboardTableLayout({
  searchValue,
  onSearchChange,
  pageSize,
  onPageSizeChange,
  children,
}) {
  return (
    <div className="p-4">
      <Card>
        <CardContent>
          <div className="flex flex-col gap-2 py-2 mb-4 sm:flex-row sm:items-center sm:justify-between">
            <Input
              type="text"
              placeholder="Rechercher..."
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              className="max-w-xs"
            />

            <Select
              value={pageSize}
              onChange={(e) => onPageSizeChange(Number(e.target.value))}
              className="px-2 py-1 ml-auto w-32 rounded border"
            >
              {[10, 20, 50].map((size) => (
                <option key={size} value={size}>
                  {size} / page
                </option>
              ))}
            </Select>
          </div>

          {children}
        </CardContent>
      </Card>
    </div>
  );
}
